exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-307b8976]{color:rgba(0,0,0,.87);margin:0}.switch-tile>div[data-v-307b8976]{padding-bottom:8px;padding-top:8px}", ""]);

// exports
